export const getAnimationSessionId = animation => animation && animation.session.id
